<form *ngIf="configForm" [formGroup]="configForm" (ngSubmit)="onSubmit(configForm)">
  <mat-card class="content-card">
    <mat-card-header>
      <mat-card-title>
        <h5>📲 Push Notification config - Customer</h5>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>

      <h5>Annual Fees</h5>


      <h5>Re-Order pending</h5>

      <mat-form-field>
        <mat-select placeholder="Re-Order Pending No Ident" formControlName="reorderPendingNoIdentTemplateId">
          <mat-option *ngFor="let template of pushNotificationTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-select placeholder="Re-Order Pending Address Unconfirmed" formControlName="reorderPendingAddressUnconfirmedTemplateId">
          <mat-option *ngFor="let template of pushNotificationTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-select placeholder="Re-Order Pending Unpaid Invoice" formControlName="reorderPendingUnpaidInvoiceTemplateId">
          <mat-option *ngFor="let template of pushNotificationTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>


      <h5>Card conversion / limit upgrade</h5>

      <mat-form-field>
        <mat-select placeholder="Card converted to physical" formControlName="cardConvertedToPhysicalTemplateId">
          <mat-option *ngFor="let template of pushNotificationTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-select placeholder="Card limits upgraded" formControlName="cardLimitsUpgradedTemplateId">
          <mat-option *ngFor="let template of pushNotificationTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <h5>Ident renewal</h5>

      <mat-form-field>
        <mat-select placeholder="Ident renewal pending" formControlName="identRenewalTemplateId">
          <mat-option *ngFor="let template of pushNotificationTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <h5>Funding</h5>

      <mat-form-field>
        <mat-select placeholder="Low on funds" formControlName="lowOnFundsTemplateId">
          <mat-option *ngFor="let template of pushNotificationTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <h5>Happy Birthday 🎉</h5>

      <mat-form-field>
        <mat-select placeholder="Happy Birthday" formControlName="happyBirthdayTemplateId">
          <mat-option *ngFor="let template of pushNotificationTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <h5>Address</h5>
      <mat-form-field>
        <mat-select placeholder="Address success template" formControlName="addressSuccessTemplateId">
          <mat-option *ngFor="let template of pushNotificationTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-select placeholder="Address failed template" formControlName="addressFailedTemplateId">
          <mat-option *ngFor="let template of pushNotificationTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>

    </mat-card-content>
    <mat-card-actions align="end">
      <button mat-button type="submit" [disabled]="!configForm.valid || configForm.pristine">
        <mat-icon>done</mat-icon>
        <a>Save</a>
      </button>
    </mat-card-actions>
  </mat-card>
</form>
